"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeAddress = exports.serializeAddress = exports.assistantAddressSchema = exports.addressSchema = void 0;
const zod_1 = require("zod");
exports.addressSchema = zod_1.z.object({
    city: zod_1.z.string(),
    state: zod_1.z.string(),
    line1: zod_1.z.string(),
    line2: zod_1.z.string().optional(),
    postalCode: zod_1.z.string(),
});
/**
 * Address variant for medical assistant profiles: every field is optional so
 * a partially filled address can be saved and completed over time. Offices
 * and doctors keep the full {@link addressSchema} requirement.
 */
exports.assistantAddressSchema = exports.addressSchema.partial();
const serializeAddress = (address) => {
    return {
        addressCity: address.city,
        addressState: address.state,
        addressLine1: address.line1,
        addressLine2: address.line2,
        addressPostalCode: address.postalCode,
    };
};
exports.serializeAddress = serializeAddress;
const deserializeAddress = (data) => {
    return {
        city: data.addressCity,
        state: data.addressState,
        line1: data.addressLine1,
        line2: data.addressLine2 ?? undefined,
        postalCode: data.addressPostalCode,
    };
};
exports.deserializeAddress = deserializeAddress;
